import React from 'react';
import { ThemeProvider as BootstrapThemeProvider } from 'react-bootstrap';
import { ThemeProvider as CustomThemeProvider } from '../../contexts/ThemeContext';
import { useThemeEffect } from '../../hooks/useThemeEffect';

const ThemeEffectWrapper = ({ children }) => {
  useThemeEffect();
  return children;
};

const ThemeProvider = ({ children }) => {
  return (
    <CustomThemeProvider>
      <ThemeEffectWrapper>
        <BootstrapThemeProvider>
          {children}
        </BootstrapThemeProvider>
      </ThemeEffectWrapper>
    </CustomThemeProvider>
  );
};

export default ThemeProvider;

